type ServiceTeamFlags = {
  is_any_service_user?: boolean;
  is_service_user?: boolean;
  is_service_admin?: boolean;
  is_service_super_admin?: boolean;
  is_inkle_admin?: boolean;
};

export const isOnServiceTeam = (user: ServiceTeamFlags = {}): boolean =>
  Boolean(user.is_any_service_user) ||
  Boolean(user.is_service_user) ||
  Boolean(user.is_service_admin) ||
  Boolean(user.is_service_super_admin) ||
  Boolean(user.is_inkle_admin);
